import { forwardRef } from 'react';

import { Box, Typography } from '@mui/material';

import { DashboardEvent } from 'features/dashboard/lib/constants';
import { trackEvent } from 'shared/lib/analytics/trackEvent';

type Props = {
  onClick?: VoidFunction;
  href: string;
};

export const VOAHeader = forwardRef<HTMLDivElement, Props>(({ onClick, href }, ref) => {
  const handleClick = () => {
    onClick?.();
    trackEvent(DashboardEvent.BANNER_CLICK, {
      type: 'voa_fannie_freddie_header',
    });
  };

  return (
    <Box
      ref={ref}
      className="group relative z-10 block w-full text-center text-white no-underline"
      component="a"
      href={href}
      rel="noreferrer"
      sx={{
        backgroundImage: 'linear-gradient(90deg, #224185 0%, #254a9e 15%, #203565 50%, #2855bb 70%, #223c79 100%)',
      }}
      target="_blank"
      onClick={handleClick}
    >
      <div className="p-4">
        <Typography className="underline" variant="body2">
          Truv Verification of Assets
        </Typography>
        <Typography className="text-white/70 group-hover:text-white" variant="body2">
          We are an authorized report supplier for Fannie Mae&apos;s Desktop Underwriter® (DU®) validation service and
          an approved support provider of Freddie Mac&apos;s Loan Product Advisor® (LPA℠) asset and income
          modeler&nbsp;(AIM).
        </Typography>
      </div>
    </Box>
  );
});

VOAHeader.displayName = 'VOAHeader';
